<div class="flex flex-wrap items-center justify-start gap-4">
  <slot />
</div>
